/**
 * EdgeStream React Context
 *
 * Provides the EdgeStream client and connection state to descendant components.
 * Create via EdgeStreamProvider wrapper component.
 */

import React from 'react';
import type { EdgeStreamContextValue } from './types';

/**
 * React context for EdgeStream client
 * @throws {Error} if used outside EdgeStreamProvider
 */
export const EdgeStreamContext = React.createContext<EdgeStreamContextValue | undefined>(undefined);

EdgeStreamContext.displayName = 'EdgeStreamContext';
